<template>
  <a-popover
    v-model="visible"
    placement="bottomRight"
    overlayClassName="message-wrapper"
    :overlayStyle="{ width: '300px' }"
    @visibleChange="fetchNotice"
  >
    <template slot="content">
      <a-spin :spinning="loading">
        <ul class="message-list">
          <template v-if="list.length">
            <li class="list-item" :key="index" v-for="(item, index) in list">
              <span :class="['dot', item.alertLevel]"></span>
              <strong v-text="item.alertModule"></strong>
              <span v-text="item.alertTime"></span>
              <p v-text="item.alertDesc"></p>
            </li>
          </template>
          <li class="tip" v-else>
            {{ $t('custom.tip.emptyText') }}
          </li>
          <li class="footer">
            <span :class="['clear', {nocur: list.length <= 0}]" @click="editMessageList">{{ $tc('private.actions.clear', 2) }}</span>
            <router-link :to="{ name: 'message' }">
              <span class="more">{{ $t('private.actions.more') }}</span>
            </router-link>
          </li>
        </ul>
      </a-spin>
    </template>
    <span class="header-notice">
      <a-badge :dot="list.length > 0" :offset="[-4, 2]">
        <a-icon type="bell" />
      </a-badge>
    </span>
  </a-popover>
</template>

<script>
import { getMessageList, editMessageList } from '@api/message'
export default {
  name: 'HeaderNotice',
  data () {
    return {
      loading: false,
      visible: false,
      list: []
    }
  },
  mounted () {
    this.getMessageList()
  },
  methods: {
    editMessageList () {
      editMessageList({ alertStatus: 'confirmed' })
        .then(res => {
          this.$message.success(this.$t('custom.tip.cleared'))
          this.getMessageList()
        })
    },
    getMessageList () {
      return getMessageList({ page: 1, size: 5, alertStatus: 'new' }).then(res => {
        this.list = res.items
      })
    },
    fetchNotice (visible) {
      if (visible) {
        this.loading = true
        this.getMessageList().then(() => {
          this.loading = false
        })
      } else {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@assets/styles/base/color.less";
.dot{
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 12px;
  margin-bottom: -4px;
  &.info{
    background-color: @info;
  }
  &.warn{
    background-color: @warn;
  }
  &.error{
    background-color: @error;
  }
  &.fatal{
    background-color: @fatal;
  }
}
.header-notice{
  display: inline-block;
  transition: all 0.3s;

  span {
    vertical-align: initial;
  }
}
.ant-popover{
  .ant-popover-content{
    margin-top: -14px;
    .ant-popover-arrow{
      display: none !important;
    }
  }
  .ant-popover-inner-content{

  }
}

.message-list{
  li{
    &.list-item{
      font-size: 12px;
      padding: 12px;
      color: #999999;
      box-shadow: 0 1px 0 0 #464646;
      strong{
        font-size: 14px;
        color: #F0F0F0;
        margin-right: 24px;
        vertical-align: middle;
      }
      span{
        vertical-align: middle;
      }
      p{
        margin-top: 6px;
        padding-left: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    &.tip{
      font-size: 14px;
      color: #f0f0f0;
      line-height: 50px;
      text-align: center;
      box-shadow: 0 1px 0 0 #464646;
    }
    &.footer{
      height: 40px;
      line-height: 40px;
      color: #999999;
      font-size: 14px;
      text-align: center;
      span{
        display: inline-block;
        width: 50%;
        cursor: pointer;
        &.more{
          color: #f0f0f0;
          background-color: #464646;
        }
      }
    }
  }
}

</style>
<style lang="less">
.message-wrapper{
  /*top: 55px !important;*/
  padding-top: 0 !important;
  .ant-popover-content{
    .ant-popover-arrow{
      display: none;
    }
    .ant-popover-inner{
      background-color: #303030;
      .ant-popover-inner-content{
        padding: 0;
      }
    }
  }
}
</style>
